$(document).ready(function(){
// on tab click toggeling class and accordian
  $('.birth_tab').on('click', function() {
    var $this = $(this);

    // Close all other tabs
    $('.birth_tab').not($this).removeClass('active').next().slideUp();

    // Toggle the clicked tab
    $this.toggleClass('active');
    $this.next().slideToggle();
});

  // ------------------------------------------------------- Birth poster related js

  
  // on animal icon change showing relevant color and setting fisrt color as true
  $('.image-list input').on('change',function(){ 
    $('.birth_main .birth_theme .color_main').removeClass('active')
    $('.birth_main .birth_theme .color_main input').prop('checked', false)
    $('[data-id="'+ $(this).attr('id')+ '"]').addClass('active')
    $('[data-id="'+ $(this).attr('id')+ '"] input[type=radio]:first-child').prop('checked', true)


    // on animal icon click selecting first clr and changing icon img
    let birthHeightIcon = $('.birthHeightIcon img')
    birthHeightIcon.attr( 'src', $(this).siblings('label').find('img').attr('src') )
    $('body').css('--selectedColor', $('[data-id="'+ $(this).attr('id')+ '"] input[type=radio]:first-child').val() ) 
  })


  // on clr icon click changing clrs
  $('.color_main input').on('change',function(){
    $('body').css('--selectedColor', $(this).val() ) 
  })


  // on change births feilds set main birth hours
  $('#birth_hr,#birth_min').on('input change',function(){
    let birth_hr = $('#birth_hr').val()
    let birth_min = $('#birth_min').val()
    if(birth_hr > 24){
      $('#birth_hr').val('01')
      birth_hr = "01"
    }else{
      if(birth_hr < 10 && birth_hr.length < 2){
        birth_hr = "0"+birth_hr
      }
    }

    
    if(birth_min > 59){
      $('#birth_min').val('01')
      birth_min = "01"
    }else{
      if(birth_min < 10 && birth_min.length < 2){
        birth_min = "0"+birth_min
      }
    }
    
    
    $('#birth_time').val( birth_hr +":"+ birth_min  )
    $('.birthTime').text(birth_hr +":"+ birth_min )
  })


  // on switch height/width change set units
  $('.switch.height input').on('change',function(){
    if( $(this).prop('checked') ){
      $('#height_unit').val('inch')
      $('.b_height_unit').text('in')
    }else{
      $('#height_unit').val('cm')
      $('.b_height_unit').text('cm')
    } 
  })
  $('.switch.weight input').on('change',function(){
    if( $(this).prop('checked') ){
      $('#weight_unit').val('lbs')
      $('.b_weight_unit_symbol').text('lbs')
    }else{
      $('#weight_unit').val('kg')
      $('.b_weight_unit_symbol').text('kg')
    }
  })


  // on birth change setting text
  $('#bDate').on('input',function(){
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    
    const parts = $('#bDate').val().split('-');
    const year = parts[0];
    const month = months[parseInt(parts[1]) - 1];
    const day = parts[2];

    $('.birthMonth').text(month)
    $('.birthDate').text(day)
    $('.birthYear').text(year)
  })


  // on change weight text
  $('#bWeight').on('input',function(){
    let weight = ''
    if($('#bWeight').val().indexOf('.') != -1 ){
      weight = $('#bWeight').val().split('.')
      $('.b_weight_val').text(weight[0])
      if(weight[1].length == 1 ){
        $('.b_weight_val_decimal').text(weight[1]+"00")
      }else if(weight[1].length == 2){
        $('.b_weight_val_decimal').text(weight[1]+"0")
      }
      else if(weight[1].length == 0){
        $('.b_weight_val_decimal').text("000")
      }
      else{
        $('.b_weight_val_decimal').text(weight[1])
      }
      
    }else{
      console.log('else')
      $('.b_weight_val').text($('#bWeight').val() || '3')
      $('.b_weight_val_decimal').text('000')
    }
  })

  
  // on change name, update name text
  setInputValText('#fName','.firstName')
  setInputValText('#mlName','.lastName')
  setInputValText('#bHeight','.b_height_val', '.b_height_unit')


  // ------------------------------------------------------- Birth poster related js ends




  // ------------------------------------------------------- where we meet related js



  // ------------------------------------------------------- where we meet related js ends





  // global function to update some input,text pairs
 function setInputValText(input, textSec, unitSec = null) {
    $(input).on('input change', function() {
        const value = $(this).val();
        $(textSec).html(value);
        if (unitSec) {
            if (value === "" || value === null) {
                $(unitSec).hide();
            } else {
                $(unitSec).show();
            }
        }
    });
}
  
})